import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(dashboard)/frais/")({
  loader: () => {
    throw redirect("/frais/me");
  },
});
